/* ---------- VariantRadios (refactor + fixes) ---------- */
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    // bind methods so 'this' is always the element instance
    this.onVariantChange = this.onVariantChange.bind(this);
    this.updateOptions = this.updateOptions.bind(this);
    this.updateMasterId = this.updateMasterId.bind(this);
    this.updateMedia = this.updateMedia.bind(this);
    this.updateURL = this.updateURL.bind(this);
    this.updateVariantInput = this.updateVariantInput.bind(this);
    this.renderProductInfo = this.renderProductInfo.bind(this);
    this.toggleAddButton = this.toggleAddButton.bind(this);
    this.setUnavailable = this.setUnavailable.bind(this);

    this.addEventListener('change', this.onVariantChange);
    // derive product-level flags once
    this.isPreOrderFlag = !!document.querySelector('.ispreordermob') || false;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // default: disable while updating
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }

  updateMasterId() {
    const variants = this.getVariantData() || [];
    // find variant whose options exactly match this.options
    this.currentVariant = variants.find((variant) => {
      // ensure both arrays exist and have same length
      if (!Array.isArray(variant.options) || !Array.isArray(this.options)) return false;
      if (variant.options.length !== this.options.length) return false;
      return variant.options.every((option, idx) => this.options[idx] === option);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const featured_id = String(this.currentVariant.featured_media.id);

    // guard selector
    const mediaThumbContainer = document.querySelector('.media-thumb');
    if (!mediaThumbContainer) return;

    const gridCols = document.querySelectorAll('.media-thumb .media-grid-column');
    if (!gridCols.length) return;

    gridCols.forEach((e) => {
      const mediaid = String(e.dataset.id);
      if (mediaid === featured_id) {
        // ensure Swiper instance exists before calling
        if (typeof Swiper !== 'undefined') {
          // safe guard: get nav swiper instance if you keep refs else fallback to global usage
          try {
            // attempt to slide the .media-nav swiper if defined globally
            if (window.mediaNavSwiper && typeof window.mediaNavSwiper.slideTo === 'function') {
              window.mediaNavSwiper.slideTo(Number(e.dataset.index || 0), 1000, false);
            } else {
              // fallback to query and create a temporary instance call if needed
              const nav = document.querySelector('.media-nav');
              if (nav && nav.swiper) nav.swiper.slideTo(Number(e.dataset.index || 0), 1000, false);
            }
          } catch (err) {
            // swallow errors to avoid breaking product page
            console.warn('updateMedia slideTo error', err);
          }
        }
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    try {
      const newUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      window.history.replaceState({}, '', newUrl);
    } catch (e) {
      console.warn('updateURL failed', e);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input || !this.currentVariant) return;
      input.value = this.currentVariant.id;
      // fire change event in case other listeners react
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;

    fieldsets.forEach((eachfield) => {
      const checked_gender = eachfield.querySelector('input:checked');
      if (checked_gender) option_count++;
    });

    // Build options array only when all options are selected
    if (option_count >= fieldlen && fieldlen > 0) {
      this.options = fieldsets.map((fieldset) => {
        const found = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        return found ? found.value : null;
      });
    } else {
      // partial selection: set to empty array (so updateMasterId won't match)
      this.options = [];
    }

    // toggle UI chooser safely
    if (window.innerWidth > 991) {
      const chooseCart = document.querySelector('.choose-cart');
      const chooseSelector = document.querySelector('.choose-selector');
      if (chooseCart && chooseSelector) {
        if (option_count >= fieldlen) {
          chooseCart.classList.remove('hide-selectore-button');
          chooseSelector.classList.add('hide-selectore-button');
        } else {
          chooseCart.classList.add('hide-selectore-button');
          chooseSelector.classList.remove('hide-selectore-button');
        }
      }
    }
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings?.soldOut || 'Sold out');
        }
      })
      .catch((err) => console.warn('renderProductInfo error', err));
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = productForm.querySelectorAll('[name="add"] .p-add-cart-btn');
    const productInventory = this.currentVariant ? this.currentVariant.inventory_quantity : undefined;

    const show = document.querySelector(".choose-cart");
    if (show && this.currentVariant !== undefined) {
      if (!this.currentVariant.available) {
        show.classList.add('show');
      } else {
        show.classList.remove('show');
      }
    }

    // set button state
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.forEach(function (addBtnText) {
        if (window.isPreOrder || (this && this.isPreOrderFlag)) {
          addBtnText.textContent = window.variantStrings?.preOrder || 'Pre-order';
        } else if (productInventory === 1) {
          addBtnText.textContent = window.variantStrings?.onlyOneLeft || 'Only one left';
        } else {
          addBtnText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }.bind(this));
      if (text) {
        addButtonText.forEach(function (addBtnText) {
          addBtnText.textContent = text;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.forEach(function (addBtnText) {
        if (window.isPreOrder || (this && this.isPreOrderFlag)) {
          addBtnText.textContent = window.variantStrings?.preOrder || 'Pre-order';
        } else if (productInventory === 1) {
          addBtnText.textContent = window.variantStrings?.onlyOneLeft || 'Only one left';
        } else {
          addBtnText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }.bind(this));
    }
    // modifyClass currently unused but kept for backward compat
    if (!modifyClass) return;
  }

  setUnavailable() {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    if (!form) return;
    const addButtonText = form.querySelectorAll('[name="add"] .p-add-cart-btn');
    addButtonText.forEach(function (addBtnText) {
      addBtnText.textContent = window.variantStrings?.unavailable || 'Unavailable';
    });
  }

  getVariantData() {
    if (!this.variantData) {
      const jsonEl = this.querySelector('[type="application/json"]');
      try {
        this.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      } catch (e) {
        this.variantData = [];
        console.warn('Could not parse variant JSON', e);
      }
    }
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);

// /* ---------- recipient-form (fix subscriptions + event.path + productId) ---------- */
// if (!customElements.get('recipient-form')) {
//   customElements.define('recipient-form', class RecipientForm extends HTMLElement {
//     constructor() {
//       super();

//       this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
//       if (this.checkboxInput) this.checkboxInput.disabled = false;

//       this.hiddenControlField = this.querySelector(`#Recipient-Control-${this.dataset.sectionId}`);
//       if (this.hiddenControlField) this.hiddenControlField.disabled = true;

//       this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
//       this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
//       this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
//       this.dateInput = this.querySelector(`#Recipient-date-${this.dataset.sectionId}`);

//       this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
//       this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
//       this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
//       this.defaultErrorHeader = this.errorMessage?.innerText || 'Please fix the following:';
//       this.currentProductVariantId = this.dataset.productVariantId;
//       // get productId from dataset if available (fallback to productVariantId if needed)
//       this.productId = this.dataset.productId || this.dataset.productVariantId || null;

//       this.onChange = this.onChange.bind(this);
//       this.addEventListener('change', this.onChange);
//     }

//     // distinct unsubscribers so we don't overwrite
//     cartAddUnsubscriber = undefined;
//     variantChangeUnsubscriber = undefined;
//     cartErrorUnsubscriber = undefined;

//     connectedCallback() {
//       // subscribe to any pub/sub you have; keep distinct variables
//       if (window.FoxThemeEvents && typeof window.FoxThemeEvents.subscribe === 'function') {
//         this.cartAddUnsubscriber = window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', (response) => {
//           this.resetRecipientForm();
//         });
//       }

//       if (window.FoxThemeEvents && typeof window.FoxThemeEvents.subscribe === 'function' && this.productId) {
//         const topic = `${this.productId}__VARIANT_CHANGE`;
//         this.variantChangeUnsubscriber = window.FoxThemeEvents.subscribe(topic, (variant) => {
//           this.currentProductVariantId = variant.id;
//         });
//       }

//       if (window.FoxThemeEvents && typeof window.FoxThemeEvents.subscribe === 'function') {
//         this.cartErrorUnsubscriber = window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS?.cartError || 'cartError', (event) => {
//           if (event.source === 'product-form' && event.productVariantId.toString() === String(this.currentProductVariantId)) {
//             this.displayErrorMessage(event.message, event.errors);
//           }
//         });
//       }
//     }

//     disconnectedCallback() {
//       if (this.cartAddUnsubscriber) this.cartAddUnsubscriber();
//       if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
//       if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();
//     }

//     onChange() {
//       if (!this.checkboxInput) return;
//       if (!this.checkboxInput.checked) {
//         this.clearInputFields();
//         this.clearErrorMessage();
//       }
//     }

//     displayErrorMessage(title, body) {
//       this.clearErrorMessage();
//       const errorSize = body && typeof body === 'object' ? Object.keys(body).length : 0;
//       if (errorSize > 1 && this.errorMessageWrapper) this.errorMessageWrapper.hidden = false;

//       if (typeof body === 'object') {
//         if (this.errorMessage) this.errorMessage.innerText = this.defaultErrorHeader;
//         return Object.entries(body).forEach(([key, value]) => {
//           const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
//           const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
//           const placeholderElement = this.querySelector(fieldSelector);
//           const label = placeholderElement?.getAttribute('placeholder') || key;
//           const message = `${label} ${value}`;
//           const errorMessageElement = this.querySelector(`#${errorMessageId}`);
//           const errorTextElement = errorMessageElement?.querySelector('.error-message');
//           if (!errorTextElement) return;

//           if (this.errorMessageList) {
//             this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
//           }

//           errorTextElement.innerText = `${message}.`;
//           errorMessageElement.classList.remove('hidden');

//           const inputElement = this[`${key}Input`];
//           if (!inputElement) return;

//           inputElement.setAttribute('aria-invalid', true);
//           inputElement.setAttribute('aria-describedby', errorMessageId);
//         });
//       }

//       if (this.errorMessage) this.errorMessage.innerText = body;
//     }

//     createErrorListItem(target, message) {
//       const li = document.createElement('li');
//       const a = document.createElement('a');
//       a.setAttribute('href', target);
//       a.innerText = message;
//       li.appendChild(a);
//       li.className = "error-message";
//       return li;
//     }

//     clearInputFields() {
//       if (this.emailInput) this.emailInput.value = '';
//       if (this.nameInput) this.nameInput.value = '';
//       if (this.messageInput) this.messageInput.value = '';
//       if (this.dateInput) this.dateInput.value = '';
//     }

//     clearErrorMessage() {
//       if (this.errorMessageWrapper) this.errorMessageWrapper.hidden = true;
//       if (this.errorMessageList) this.errorMessageList.innerHTML = '';
//       this.querySelectorAll('.f-recipient-fields .f-form__message').forEach((field) => {
//         field.classList.add('hidden');
//         const textField = field.querySelector('.error-message');
//         if (textField) textField.innerText = '';
//       });

//       [this.emailInput, this.messageInput, this.nameInput, this.dateInput].forEach((inputElement) => {
//         if (!inputElement) return;
//         inputElement.setAttribute('aria-invalid', false);
//         inputElement.removeAttribute('aria-describedby');
//       });
//     }

//     resetRecipientForm() {
//       if (this.checkboxInput && this.checkboxInput.checked) {
//         this.checkboxInput.checked = false;
//         this.clearInputFields();
//         this.clearErrorMessage();
//       }
//     }
//   });
// }
function variant_drodown() {
  if (document.querySelector('.dropdown-wrap')) {
    document.querySelectorAll('.dropdown-wrap').forEach(function (dropdown) {
      const trigger = dropdown.querySelector('.variant-dropdown');
      if (!trigger) return;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function (e) {
          e.addEventListener('change', function (ev) {
            dropdown.classList.remove('active');
            // prefer ev.target.value
            const val = ev.target?.value || ev.currentTarget?.value || '';
            const inner = dropdown.querySelector('.variant-dropdown');
            if (inner) inner.innerHTML = val;
          });
        });
      });
    });
  }
}
document.querySelectorAll('.size-btn').forEach(function(sizebtn){
  sizebtn.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('open-popup');
  });
});
if(document.querySelector('.size-popup-close') != null){
  document.querySelector('.size-popup-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-popup');
  })
}
if(document.querySelector('.product-addcart') != null){
  let giftCardMobileState = 'select';
  document.querySelector('.product-addcart').addEventListener('click', function(evt) {
    evt.preventDefault();
    const productWrap = document.querySelector('.product-wrap');
    const isGiftCard = productWrap && productWrap.classList.contains('gift-product');
    const isMobile = window.innerWidth < 991;
    if (isMobile && isGiftCard) {
      if (giftCardMobileState === 'select') {
        document.querySelector('body').classList.add('open-select-size');
        giftCardMobileState = 'add';
      } else {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var cartform = document.querySelector('.product-addcart').closest('form');
        console.log("id",cartform.querySelector('input[name=\"id\"]').value)
        const formData = new FormData(cartform);  
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          if (response.status) {
            let errorMsg = window.cartStrings.quantityError;
            // Prefer the main message if present
            if (response.errors.email && response.message) {
              let sanitized = String(response.message)
                .replace(/^Validation failed:\s*/i, '')
                .replace(/<[^>]*>/g, '')
                .trim();
              errorMsg = sanitized || window.cartStrings.quantityError;
            }
            document.querySelector('.d-prod-error').innerHTML = errorMsg;
            document.querySelector('.d-prod-error').classList.add('slide-in');
            setTimeout(function(e){
              document.querySelector('.d-prod-error').classList.remove('slide-in');
              document.querySelector('.d-prod-error').classList.add('slide-out');
              setTimeout(function() {
                document.querySelector('.d-prod-error').innerHTML = '';
                document.querySelector('.d-prod-error').classList.remove('slide-out');
              }, 500); // Match this duration with the slide-out animation duration
            }, 5000);
            return;
          } else {
            if(typeof load_cart == 'function'){
              load_cart();
            }else{
              window.location.href = "/cart";
            }
          }
          document.querySelector('.product-addcart').classList.add('product-added');
          setTimeout(function(e){
            document.querySelector('.product-addcart').classList.remove('product-added')
          },4000);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {

        });
        // Reset state for next add
        giftCardMobileState = 'select';
        document.querySelector('body').classList.remove('open-select-size');
      }
    } else {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var cartform = document.querySelector('.product-addcart').closest('form');
      console.log("id",cartform.querySelector('input[name=\"id\"]').value)
      const formData = new FormData(cartform);  
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.status) {
          let errorMsg = window.cartStrings.quantityError;
          // Prefer the main message if present
          if (response.errors.email && response.message) {
            let sanitized = String(response.message)
              .replace(/^Validation failed:\s*/i, '')
              .replace(/<[^>]*>/g, '')
              .trim();
            errorMsg = sanitized || window.cartStrings.quantityError;
          }
          document.querySelector('.d-prod-error').innerHTML = errorMsg;
          document.querySelector('.d-prod-error').classList.add('slide-in');
          setTimeout(function(e){
            document.querySelector('.d-prod-error').classList.remove('slide-in');
            document.querySelector('.d-prod-error').classList.add('slide-out');
            setTimeout(function() {
              document.querySelector('.d-prod-error').innerHTML = '';
              document.querySelector('.d-prod-error').classList.remove('slide-out');
            }, 500); // Match this duration with the slide-out animation duration
          }, 5000);
          return;
        } else {
          if(typeof load_cart == 'function'){
            load_cart();
            setTimeout(function(e){
              document.querySelector('body').classList.add('open-drawer');
            },500);
          }else{
            window.location.href = "/cart";
          }
        }
        document.querySelector('.product-addcart').classList.add('product-added')
        setTimeout(function(e){
          document.querySelector('.product-addcart').classList.remove('product-added')
        },4000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
    
      });
    }
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
  var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  document.querySelector('.choose-selector a').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.choose-selector').classList.add('active');
    if(window.innerWidth < 641){
      doScrolling.bind(null, '#product-form-installment', 2000)
    }
  })
  // if (window.innerWidth < 641) {
  //   document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  // }
}
if(document.querySelector('.prod-sticky-init') != null){
  const ctaButtons = document.querySelectorAll('.prod-sticky-init');

  ctaButtons.forEach(button => {
    button.addEventListener('click',function(e){
      e.preventDefault();
      // if(!document.querySelector('.size-selector').classList.contains('prod-soldout')){
        document.querySelector('body').classList.add('open-select-size');
        document.querySelectorAll('.sticky-variant-grid').forEach(function(stickyVariant){
          if(stickyVariant.classList.contains("active")){
            stickyVariant.classList.remove("active");
          }
        })
      // }
    })
  });
}
if(document.querySelectorAll('.sticky-variant-grid') != null){
  // document.querySelectorAll('.sticky-variant-grid').forEach(function(stickyVariant){
  //   stickyVariant.addEventListener('click',function(e){
  //     e.preventDefault();
  //     document.querySelector('.mb-add-to-cart').setAttribute('data-id',stickyVariant.getAttribute('data-id'))
  //     if(stickyVariant.classList.contains("active")){
  //       stickyVariant.classList.remove("active");
  //       document.querySelector('.snippet-product-sticky-bar').classList.remove('active');
  //     }else{
  //       const stickyVariantsWithIsOpen = document.querySelectorAll(".sticky-variant-grid.active");
  //       stickyVariantsWithIsOpen.forEach((stickyVariantWithIsOpen) => {
  //         stickyVariantWithIsOpen.classList.remove("active");
  //         document.querySelector('.snippet-product-sticky-bar').classList.remove('active');
  //       });
  //       stickyVariant.classList.add("active");
  //       document.querySelector('.snippet-product-sticky-bar').classList.add('active');
  //     }
  //     if(stickyVariant.closest('li').classList.contains('disabled-variant')){
  //       document.querySelector('.mb-add-to-cart').classList.add('mb_soldOut','klaviyo-bis-trigger')
  //     }else{
  //       document.querySelector('.mb-add-to-cart').classList.remove('mb_soldOut','klaviyo-bis-trigger')
  //     }
  //   })
  // })
  document.querySelectorAll('.sticky-variant-grid').forEach(function(stickyVariant) {
    stickyVariant.addEventListener('click', function(e) {
      e.preventDefault();
      const mbAddToCartButtons = document.querySelectorAll('.mb-add-to-cart');
      mbAddToCartButtons.forEach(button => {
        button.setAttribute('data-id', stickyVariant.getAttribute('data-id'));
      });
  
      if (stickyVariant.classList.contains("active")) {
        stickyVariant.classList.remove("active");
        document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
          bar.classList.remove('active');
        });
      } else {
        const stickyVariantsWithIsOpen = document.querySelectorAll(".sticky-variant-grid.active");
        stickyVariantsWithIsOpen.forEach((stickyVariantWithIsOpen) => {
          stickyVariantWithIsOpen.classList.remove("active");
          document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
            bar.classList.remove('active');
          });
        });
        stickyVariant.classList.add("active");
        document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
          bar.classList.add('active');
        });
      }
  
      if (stickyVariant.closest('li').classList.contains('disabled-variant')) {
        mbAddToCartButtons.forEach(button => {
          button.classList.add('mb_soldOut', 'klaviyo-bis-trigger');
        });
      } else {
        mbAddToCartButtons.forEach(button => {
          button.classList.remove('mb_soldOut', 'klaviyo-bis-trigger');
        });
      }
    });
  });
}
const mbAddToCartButtons = document.querySelectorAll('.mb-add-to-cart');
if(mbAddToCartButtons.length > 0){
  mbAddToCartButtons.forEach(mbAddToCart => {
    mbAddToCart.addEventListener('click',function(e){
      e.preventDefault();
      if (mbAddToCart.classList.contains('mb_soldOut')) {
        // Open the Klaviyo popup and do not proceed with adding to cart
        mbAddToCart.click();
        return;
      }     
      let variant_id = mbAddToCart.dataset.id;
      let error_grid_outer = mbAddToCart.closest('.section-product');
      let error_grid = error_grid_outer.querySelector('.mb-prod-error');
      let isPreOrder = false;
      let preOrderValue = 'No';
      if (document.querySelector('.ispreordermob')) {
        isPreOrder = true;
        let productCard = document.querySelector('.ispreordermob');
        if (productCard) {
          preOrderValue = productCard.getAttribute('data-preorder');
        }
      }
      let formData = {
        'items': [{
          'id': variant_id,
          'quantity': 1,
          'properties': {"Pre-order item": "No"},
        }]
      };

      if (isPreOrder) {
        formData.items[0].properties = {"Pre-order item": preOrderValue};
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        if(data.status == 422){
          error_grid.innerHTML = window.cartStrings.quantityError;
          error_grid.classList.add('slide-in');

          setTimeout(function(e){
            error_grid.classList.remove('slide-in');
            error_grid.classList.add('slide-out');
            setTimeout(function() {
              error_grid.innerHTML = '';
              error_grid.classList.remove('slide-out');
            }, 500);
          }, 5000);
        }else{          
          if(document.location.href.indexOf('/cart') > -1) {
            window.location.href = "/cart";
          }else{
            if(typeof load_cart == 'function'){
              load_cart();
              setTimeout(function(e){
                document.querySelector('body').classList.remove('open-select-size');
                document.querySelector('body').classList.add('open-mb-cart');
                document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
                  bar.classList.remove('active');
                });
                setTimeout(function(e){
                  document.querySelector('body').classList.remove('open-mb-cart');
                },4000);
              },500);
            }else{
              window.location.href = "/cart";
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
    })
  });
}
const mbCartDrawerButtons = document.querySelectorAll('.mb-cart-drawer, .gift-card-drawer');
if (mbCartDrawerButtons.length > 0) {
  mbCartDrawerButtons.forEach(mbCartDrawer => {
    mbCartDrawer.addEventListener('click',function(e){
      e.preventDefault();
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          document.querySelector('body').classList.add('open-drawer');
        }        
      }
    })
  });
}
function stickyScroll(){
  const productWrap = document.querySelector('.product-wrap');
  const isGiftCard = productWrap && productWrap.classList.contains('gift-product');
  const ctaButtonBelowColors = isGiftCard
    ? document.querySelector('.snippet-addto-cart')
    : document.querySelector('.mobile-cta-below-colors');
  const fixedCtaButton = document.querySelector('.mobile-cta-fixed-button');
  window.addEventListener('scroll', (e) => {
    let scroll = window.scrollY;
    let buttonPosition = ctaButtonBelowColors ? ctaButtonBelowColors.getBoundingClientRect().top + window.scrollY : 0;
    let windowHeight = window.innerHeight;

    if (
      ctaButtonBelowColors &&
      scroll + windowHeight >= buttonPosition &&
      scroll <= buttonPosition + ctaButtonBelowColors.offsetHeight
    ) {
      document.querySelector('body').classList.remove('stickybar');
      document.querySelector('body').classList.remove('open-select-size');
    } else {
      document.querySelector('body').classList.add('stickybar');
    }
  });
}
stickyScroll();
document.addEventListener("DOMContentLoaded", () => {
  stickyScroll();
});
if(document.querySelector('.size-popup-close') != null){
  document.querySelector('.size-popup-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-popup');
  })
}
addEventListener("DOMContentLoaded", (event) => {
  document.querySelector('.prod-content').style.maxHeight = document.querySelector('.prod-content .prod-content-inr').clientHeight+'px'
});
function updSwiperNumericPagination(){
  document.querySelector(".prod-counter").innerHTML = '<span class="count">' + (this.realIndex + 1) + '</span>/<span class="total">' + this.slides.length + "</span>";
}
var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 991) {
    if (!init) {
      init = true;
      swiper = new Swiper(".media-grid.swiper", {
        direction: "horizontal",
        slidesPerView: "auto",
        centeredSlides: true,
        navigation: {
          nextEl: ".prod-arrows.swiper-button-next",
          prevEl: ".prod-arrows.swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          init: updSwiperNumericPagination,
          slideChange: updSwiperNumericPagination
        }
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
function boxHeight(){
  document.querySelector('.media-thumb-cursor').style.height = (100 * window.innerHeight) / document.querySelector('.product-media').clientHeight + '%'
}
addEventListener("DOMContentLoaded", boxHeight)
addEventListener("resize", boxHeight)
window.addEventListener('scroll', (e)=>{
  let scrollDistance = window.pageYOffset
  if(scrollDistance > 0){
    document.querySelector('.prod-content').style.maxHeight = '0px'
    document.querySelector('.section-product').classList.add('scroll-start')
  }else{
    document.querySelector('.prod-content').style.maxHeight = document.querySelector('.prod-content .prod-content-inr').clientHeight+'px'
    document.querySelector('.section-product').classList.remove('scroll-start')
  }
  let mediaCount = document.querySelectorAll('.media-thumb').length
  var mainScroll = (scrollDistance / (document.querySelector('.product-media').clientHeight - window.innerHeight)) * 100;
  var thumbScroll = (scrollDistance / (document.querySelector('.prod-thumb-inr .medialist').clientHeight - window.innerHeight)) * 100;
  let mainCurrent = parseFloat(((scrollDistance / document.querySelector('.product-media').clientHeight) * 100).toFixed(2))
  let thumbCurrent = parseFloat((((scrollDistance + document.querySelector('.media-thumb-cursor').clientHeight) / document.querySelector('.prod-thumb-inr .medialist').clientHeight) * 100).toFixed(2))
  if(mainScroll <= 100){
    document.querySelector('.media-thumb-cursor').style.top = mainCurrent +'%'
  }
})
// if(document.querySelector('.prod-thumb-inr .medialist')){
//   document.querySelector('.prod-thumb-inr .medialist').addEventListener('click',function(e){
//     document.querySelector('html').style.scrollBehavior = 'unset'
//     let top = (e.clientY - this.offsetTop)/(this.clientHeight/100)
//     document.querySelector(".media-thumb-cursor").style.top = top+'%'
//     document.scrollingElement.scrollTop = (document.querySelector('.product-media').clientHeight/100)*top
//   });
// }
var parentBox = document.getElementById('mediaThumbDragParent');
var box = document.getElementById('mediaThumbDragBox');
// Variables to track if mouse is down (clicked) or up
var isMouseDown = false;
// Variables to store initial mouse position and box position in percentages
var initialMouseX, initialMouseY, initialBoxX, initialBoxY;
// Add event listeners
box.addEventListener('mousedown', handleMouseDown);
document.addEventListener('mouseup', handleMouseUp);
document.addEventListener('mousemove', handleMouseMove);
function handleMouseDown(event){
  // Mark the mouse as being down
  isMouseDown = true;
  // Record the initial mouse coordinates
  initialMouseX = event.clientX;
  initialMouseY = event.clientY;
  // Convert the box's position to percentage of the parentBox's dimensions
  initialBoxX = box.offsetLeft / parentBox.offsetWidth * 100;
  initialBoxY = box.offsetTop / parentBox.offsetHeight * 100;
}
function handleMouseUp(){
  // Mark the mouse as being up
  isMouseDown = false;
}
function handleMouseMove(event){
  if(!isMouseDown){
    return;
  }
  // Calculate the difference in position
  var deltaX = (event.clientX - initialMouseX) / parentBox.offsetWidth * 100;
  var deltaY = (event.clientY - initialMouseY) / parentBox.offsetHeight * 100;
  // Calculate new position in percentages
  var newLeft = initialBoxX + deltaX;
  var newTop = initialBoxY + deltaY;
  // Calculate the box's own dimensions as percentages of the parent box
  var boxWidthPct = box.offsetWidth / parentBox.offsetWidth * 100;
  var boxHeightPct = box.offsetHeight / parentBox.offsetHeight * 100;
  // Prevent the box from moving outside the parentBox
  newLeft = Math.max(Math.min(newLeft, 100 - boxWidthPct), 0);
  newTop = Math.max(Math.min(newTop, 100 - boxHeightPct), 0);
  // Apply the new position
  box.style.left = newLeft + '%';
  box.style.top = newTop + '%';
  const getSectionHeight = document.querySelector('.product-wrap').offsetHeight / 100;
//  window.scrollTo({top: (getSectionHeight*newTop),behavior: "auto"});
  document.documentElement.scrollTop = getSectionHeight * newTop;
}
if(document.querySelector('.prod-thumb-inr .medialist')){
  document.querySelector('.prod-thumb-inr .medialist').addEventListener('dblclick',function(e){
    document.querySelector('html').style.scrollBehavior = 'unset'
    let top = (e.clientY - this.offsetTop)/(this.clientHeight/100)
      document.querySelector(".media-thumb-cursor").style.top = top+'%'
      document.scrollingElement.scrollTop = (document.querySelector('.product-media').clientHeight/100)*top
  });
}


document.addEventListener("DOMContentLoaded", () => {
  const stickyVariantGrids = document.querySelectorAll('.sticky-variant-grid');
  const mbAddedElements = document.querySelectorAll('.mb-added:not(.product-sticky-bar-btm .mb-added)');


  stickyVariantGrids.forEach(stickyVariantGrid => {
    stickyVariantGrid.addEventListener('click', function(event) {
      event.preventDefault();
      const productInventoryMob = this.getAttribute('inventory');      
      mbAddedElements.forEach(mbAdded => {
      if (isPreOrder) {
        mbAdded.textContent = window.variantStrings.preOrder;
      } 
      else if (productInventoryMob == 1) {
        mbAdded.textContent = window.variantStrings.onlyOneLeft;
      }
      else {
        mbAdded.textContent = window.variantStrings.addToCart;
      }
      });
    });
  });
});